export default "__VITE_ASSET__CP9Y9IRQ__"